import { trackForwardedComponent } from '../../util/trackComponent.js';
import { Box } from './Box.js';
import './Box.types.js';

var BoxWithTracking = trackForwardedComponent(Box);

export { BoxWithTracking as Box };
//# sourceMappingURL=external.js.map
